/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import CenteredBriefBlogCard from "examples/Cards/BlogCards/CenteredBriefBlogCard";

function Products() {

  const vehicle = [
  {
    image: require("assets/images/product/hb20.jpg"),
    title: "HB20",
    link: "/product/hb20",
  },
  {
    image: require("assets/images/product/hb20s.jpg"),
    title: "HB20s",
    link: "/product/hb20s",
  },
  {
    image: require("assets/images/product/creta.jpg"),
    title: "NUEVA CRETA",
    link: "/product/creta",
  },
  {
    image: require("assets/images/product/tucson.jpg"),
    title: "NEW TUCSON",
    link: "/product/tucson",
  },
  {
    image: require("assets/images/product/tucson.jpg"),
    title: "NEW TUCSON HYBRID",
    link: "/product/tucson_hibrido",
  },
  {
    image: require("assets/images/product/staria.jpg"),
    title: "STARIA",
    link: "/product/staria",
  },
  {
    image: require("assets/images/product/veloster.jpg"),
    title: "VELOSTER N",
    link: "/product/veloster",
  },
  {
    image: require("assets/images/product/hd78.jpg"),
    title: "HD-78",
    link: "/product/hd78",
  },
];

  const renderVehicleCards = vehicle.map((item, index) => (
          <Grid key={item.title} item xs={12} sm={6} lg={3}>
            <MKBox mb={6}>
              <CenteredBriefBlogCard
                image={item.image}
                action={{
                  type: "internal",
                  route: item.link,
                  color: "info",
                  label: item.title,
                }}
              />
            </MKBox>
          </Grid>
  ));

  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={8}>
            Modelos
          </MKTypography>
        </Grid>

        <Grid container spacing={3}>
          {renderVehicleCards}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Products;
